export enum ApplicationServiceErrorCode {
  GENERAL,
}

export interface ApplicationFailure {
  message: string
}

export declare type SearchPages = 'search' | 'searchbic'

export declare type ViewPages =
  | 'base'
  | 'grpmembers'
  | 'linkedfiles'
  | 'decisions'
  | 'statehistory'
  | 'comittee'
  | 'comitteedetails'
  | 'collaterals'
  | 'bic'
  | 'custfields'
  | 'accessperms'
  | 'decisioneligible'
  | 'printappdetails'
  | 'printappbic'
  | 'dmlog'
  | 'printappdetails'

export declare type CommitteeActions =
  | 'approve'
  | 'reject'
  | 'suspend'
  | 'delete'
  | 'view'
  | 'viewstatushistory'
  | 'validate'
  | 'viewcustfields'

export declare type OperActions =
  | 'accesspermadd'
  | 'accesspermdelete'
  | 'undotoscreening'
  | 'expire'
  | 'expireundo'
  | 'agreementnumberupdate'
  | 'dmprocess'
  | 'screeningreject'
  | 'screeningrejectundo'
  | 'send'
  | 'return'

export declare type OperPostActions = 'send' | 'return'

export declare type ApplicationAddAction = 'add' | 'edit' | 'delete'
